module.exports = __webpack_public_path__ + "media/images/coupon/img-coupon-name-1b00ce5d71febc5e9f833b9581e1daf9.png";